import React, { useEffect } from "react";

import ContentContainer from "components/Container";
import { logError } from "api/accounts-customer";

export const Error = () => {
  useEffect(() => {
    logError({}, { flowLoc: "ERROR" });
  }, []);

  // TODO: Use the full page error component here
  return <ContentContainer>ERROR</ContentContainer>;
};
